module.exports = __webpack_public_path__ + "static/media/corona4.1ad0ec16.jpeg";